// Workshop access levels, shared by the app and Netlify functions. Must match
// public.workshop_access_level() in
// supabase/migrations/20261021210000_workshop_access_levels.sql;
// scripts/workshop-access-db-checks.cjs compares the two.
//   full      active, comped, past_due (Stripe still retrying), trial not yet ended
//   read_only pending or incomplete signup; otherwise for 90 days after subscription_end
//   none      archived, or more than 90 days after subscription_end
const READ_ONLY_DAYS = 90
const DAY_MS = 24 * 60 * 60 * 1000

const READ_ONLY_MESSAGE = 'This workshop is read-only because its subscription has ended. Reactivate the subscription to make changes.'
const NO_ACCESS_MESSAGE = 'This workshop no longer has access to Rebound.'

function time(value) {
  const parsed = Date.parse(value || '')
  return Number.isNaN(parsed) ? null : parsed
}

function workshopAccessLevel(workshop, now = Date.now()) {
  if (!workshop || workshop.archived_at) return 'none'
  const status = String(workshop.subscription_status || '').toLowerCase()
  const end = time(workshop.subscription_end)
  if (['active', 'comped', 'past_due'].includes(status)) return 'full'
  if (status === 'trialing' && end !== null && end > now) return 'full'
  if (['pending', 'incomplete'].includes(status)) return 'read_only'
  const from = end ?? time(workshop.created_at)
  return from !== null && from + READ_ONLY_DAYS * DAY_MS > now ? 'read_only' : 'none'
}

// When a read-only workshop loses access, or null if it doesn't run out.
function readOnlyUntil(workshop) {
  const status = String(workshop?.subscription_status || '').toLowerCase()
  if (['pending', 'incomplete'].includes(status)) return null
  const from = time(workshop?.subscription_end) ?? time(workshop?.created_at)
  return from === null ? null : new Date(from + READ_ONLY_DAYS * DAY_MS)
}

module.exports = { workshopAccessLevel, readOnlyUntil, READ_ONLY_MESSAGE, NO_ACCESS_MESSAGE }
